// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1RL04","title":"AfterFrontImage_title__15LFy"};